import { FunctionComponent, ReactNode } from "react";

type ValidationWrapperProps = {
  error?: string | null;
  children: ReactNode | ReactNode[];
};

export const ValidationWrapper: FunctionComponent<ValidationWrapperProps> = ({
  error,
  children,
}: ValidationWrapperProps) => {
  return (
    <>
      {children}
      {error && <div className="text-error-500 text-sm mt-2">{error}</div>}
    </>
  );
};
